import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  DomSanitizer,
  SafeUrl,
  SafeResourceUrl,
} from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorModalComponent } from 'src/app/common/error-modal/error-modal.component';
import { EncryptionService } from 'src/app/services/encryption.service';
import { AppService } from 'src/app/services/services';

@Component({
  selector: 'nri-app-aof',
  templateUrl: './aof.component.html',
  styleUrls: ['./aof.component.scss'],
})
export class AofComponent implements OnInit {
  objURl: SafeUrl | undefined;
  erefNo: any;
  remarks: string;
  panNumber: string = '';
  NRO: string = '';
  @ViewChild('pdfViewer') pdfViewer: any;
  @ViewChild('errorComp') errorComp: ErrorModalComponent;
  Esignmsg: string = '';
  EsignStatus: string = '';
  esignMessage: string = '';
  search: any = {};
  completeModal: any;
  formAction: string | null = null;
  esignRequestXml: string = '';
  esignApiUrl: string = '';
  esignstage: boolean = false;
  retryCount = 0;
  @ViewChild('frmMain', { static: false })
  frmMain!: ElementRef<HTMLFormElement>;
  constructor(
    private sanitizer: DomSanitizer,
    private loader: NgxUiLoaderService,
    private http: EncryptionService,
    private toastr: ToastrService,
    private _http: AppService,
    private router: Router,
    public encrypt: EncryptionService,
  ) {
    this._http.getRefNum().subscribe((data) => {
      this.erefNo = data;
    });
    this._http.getStatus().subscribe((data) => {
      this.panNumber = data.Pan;
    });
  }
  ngOnInit() {
    if (sessionStorage.getItem('searchParams')) {
      this.search = JSON.parse(sessionStorage.getItem('searchParams') || '{}');
    }
    if (Object.keys(this.search).length > 0) {
      this.Esignmsg = this.search['msg'];
      this.EsignStatus = this.search['esign'];
      this.esignMessage = this.search['code'];
    }
    if (this.EsignStatus) {
      if (this.EsignStatus?.toLowerCase() === 'true') {
        this.esignstage = true;
      }
    }
    // this.objURl = this.sanitizer.bypassSecurityTrustResourceUrl('./assets/sbiPdf.pdf');
    let host: string = window.location.hostname;
    let pbURL: string = '';
    if (
      host === 'localhost' ||
      host === '15.206.52.226' ||
      host === 'dotnet.constient.com'
    ) {
      pbURL = `https://dotnet.constient.com/SBINRIDemoDIY/PdfHtml/dummy.html?ReferenceNumber=${this.erefNo}&Preview=true`;
    } else if (host === 'predigikyc.sbicapsec.com') {
      pbURL = `https://predigikyc.sbicapsec.com/SBINRI_DIY/PdfHtml/dummy.html?ReferenceNumber=${this.erefNo}&Preview=true`;
    } else if (host === 'preopendemataccount.sbicapsec.com') {
      pbURL = `https://preopendemataccount.sbicapsec.com/SBINRI_DIY/PdfHtml/dummy.html?ReferenceNumber=${this.erefNo}&Preview=true`;
    } else {
      pbURL = `https://opendemataccount.sbisecurities.in/SBINRIDIY/PdfHtml/dummy.html?ReferenceNumber=${this.erefNo}&Preview=true`;
    }
    this.objURl = this.sanitizer.bypassSecurityTrustResourceUrl(pbURL);
    // this.previewAOF();

    let refNo = sessionStorage.getItem('AxNo');
    if (refNo) {
      this.getDIYStatus(refNo);
    }
    this._http.scroll();
    if (this.EsignStatus?.toLowerCase() === 'true') {
      this.toastr.success('Success');
      this.stageValidate();
    }

    // this.GeneratePDF()
  }
  ngAfterViewInit() {}
  getDIYStatus(ref: any) {
    let url = 'DIY/DIYOverallStatus';
    const checkSum = ref;
    let params = {
      ReferenceNumber: ref,
    };
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data: any) => {
        this.loader.stop();
        let value = this.encrypt.decryptUsingAES256(data.OutPut);
        if (value && value.IsSuccess) {
          let item = value.overallLists;
          let refNo = value.ReferenceNumber;
          this.NRO = value.NRO;
          if (value.PanNumber) {
            this.panNumber = value.PanNumber;
          }
          if (item[1].DIY !== 'Y' || item[1].DBO === 'R') {
            if (item[1].DBO !== 'R') {
              this.router.navigate(['/pan'], { replaceUrl: true });
            }
            if (item[1].DBO === 'R') {
              this.errorComp.ModalShow(item[1].Remarks, true, '/pan');
            }
          } else if (
            (item[12].DIY !== 'Y' || item[12].DBO === 'R') &&
            value.NRO === 'Y'
          ) {
            this.router.navigate(['/photo'], { replaceUrl: true });
            if (item[12].DBO === 'R') {
              this.remarks = item[12].Remarks;
              this.errorComp.ModalShow(item[12].Remarks);
            }
          } else if (item[2].DIY !== 'Y' || item[2].DBO === 'R') {
            if (item[2].DBO !== 'R') {
              this.router.navigate(['/passport'], { replaceUrl: true });
            }
            if (item[2].DBO === 'R') {
              this.errorComp.ModalShow(item[2].Remarks, true, '/passport');
            }
          } else if (
            (item[3].DIY !== 'Y' || item[3].DBO === 'R') &&
            item[3].StageSkip == 'F'
          ) {
            // this.router.navigate(['/oci-pio'], { replaceUrl: true });
            if (item[3].DBO !== 'R') {
              this.router.navigate(['/oci-pio'], { replaceUrl: true });
            }
            if (item[3].DBO === 'R') {
              this.errorComp.ModalShow(item[3].Remarks, true, '/oci-pio');
            }
          } else if (item[4].DIY !== 'Y' || item[4].DBO === 'R') {
            if (item[4].DBO !== 'R') {
              this.router.navigate(['/foreign-address'], { replaceUrl: true });
            }
            if (item[4].DBO === 'R') {
              this.errorComp.ModalShow(
                item[4].Remarks,
                true,
                '/foreign-address',
              );
            }
          } else if (item[5].DIY !== 'Y' || item[5].DBO === 'R') {
            if (item[5].DBO !== 'R') {
              this.router.navigate(['/address'], { replaceUrl: true });
            }
            if (item[5].DBO === 'R') {
              this.remarks = item[5].Remarks;
              this.errorComp.ModalShow(item[5].Remarks, true, '/address');
              // this.errorComp.ModalShow(item[5].Remarks)
            }
          } else if (
            (item[6].DIY !== 'Y' || item[6].DBO === 'R') &&
            item[3].StageSkip !== 'F'
          ) {
            if (item[6].DBO === 'R') {
              this.errorComp.ModalShow(item[6].Remarks, true, '/visa');
            }
            if (item[6].DBO !== 'R') {
              this.router.navigate(['/visa'], { replaceUrl: true });
            }
          } else if (item[7].DIY !== 'Y' || item[7].DBO === 'R') {
            if (item[7].DBO === 'R') {
              this.errorComp.ModalShow(item[7].Remarks, true, '/fatca');
            }
            if (item[7].DBO !== 'R') {
              this.router.navigate(['/fatca'], { replaceUrl: true });
            }
          } else if (item[9].DIY !== 'Y' || item[9].DBO === 'R') {
            if (item[9].DBO === 'R') {
              this.errorComp.ModalShow(item[9].Remarks, true, '/bank');
            }
            if (item[9].DBO !== 'R') {
              this.router.navigate(['/bank'], { replaceUrl: true });
            }
          } else if (item[10].DIY !== 'Y' || item[10].DBO === 'R') {
            if (item[10].DBO === 'R') {
              this.errorComp.ModalShow(item[10].Remarks, true, '/segments');
            }
            if (item[10].DBO !== 'R') {
              this.router.navigate(['/segments'], { replaceUrl: true });
            }
          } else if (item[11].DIY !== 'Y' || item[11].DBO === 'R') {
            if (item[11].DBO === 'R') {
              this.errorComp.ModalShow(item[11].Remarks, true, '/fatca');
            }
            if (item[11].DBO !== 'R') {
              this.router.navigate(['/fatca'], { replaceUrl: true });
            }
          } else if (
            (item[13].DIY !== 'Y' || item[13].DBO === 'R') &&
            value.NRO === 'Y'
          ) {
            this.router.navigate(['/signature'], { replaceUrl: true });
            if (item[13].DBO === 'R') {
              this.remarks = item[13].Remarks;
              this.errorComp.ModalShow(item[13].Remarks);
            }
          } else {
            setTimeout(() => {
              if (!this.esignstage) {
                if (this.NRO === 'Y') {
                  this.ddpinum();
                } else {
                  this.GeneratePDF();
                }
              }
            }, 100);
          }
        }
      },
      error: (_error) => {
        this.loader.stop();
      },
    });
  }
  ddpinum() {
    let url = 'DIY/GetSerialNumber?ReferenceNumber=' + this.erefNo;
    this.loader.start();
    this._http.httpGet(url).subscribe({
      next: (data: any) => {
        this.loader.stop();
        if (data.IsSuccess && data.DDPISerialNumber) {
          this.GeneratePDF();
        }
      },
    });
  }
  nextStage() {
    if (this.NRO === 'Y' && this.EsignStatus.toLowerCase() !== 'true') {
      let surl = 'DIY/CheckPDFDocument';
      const checkSum = this.erefNo;

      let params = {
        ReferenceNumber: this.erefNo,
        PanNumber: this.panNumber ? this.panNumber : '',
        IsDBO: false,
        NRO: this.NRO,
      };

      this.loader.start();

      this._http.httpPost(surl, params, checkSum).subscribe({
        next: (data: any) => {
          let response = this.encrypt.decryptUsingAES256(data.OutPut);

          if (response.IsSuccess) {
            this.retryCount = 0;

            let url = 'DIY/GenerateESignRequestXML';
            let params = {
              ReferenceNumber: this.erefNo,
              Source: 'DIY',
            };

            this._http.httpPost(url, params, checkSum).subscribe({
              next: (data: any) => {
                this.loader.stop();
                let eresponse = this.encrypt.decryptUsingAES256(data.OutPut);

                if (
                  eresponse.IsSuccess &&
                  eresponse.requestXml &&
                  eresponse.eSignApiUrl
                ) {
                  this.esignRequestXml = eresponse.requestXml;
                  this.esignApiUrl = eresponse.eSignApiUrl;

                  setTimeout(() => {
                    if (this.frmMain) {
                      this.frmMain.nativeElement.submit();
                    } else {
                      console.error('Form not found');
                    }
                  }, 50);
                }
              },
            });
          } else {
            this.retryCount++;

            if (this.retryCount < 3) {
              console.log(`Retrying CheckPDFDocument : ${this.retryCount}`);
              this.nextStage();
            } else {
              this.loader.stop();
              this.retryCount = 0;
              this.toastr.error('Falied');
            }
          }
        },
        error: () => {
          this.retryCount++;

          if (this.retryCount < 3) {
            this.nextStage();
          } else {
            this.loader.stop();
            this.retryCount = 0;
            this.toastr.error('Falied');
          }
        },
      });
    } else if (this.NRO === 'Y' && this.EsignStatus.toLowerCase() === 'true') {
      this.stageValidate();
    } else {
      const element = document.getElementById('complete') as HTMLElement;
      this.completeModal = new Modal(element, {
        backdrop: 'static',
        keyboard: false,
      });
      this.completeModal.show();
    }
  }

  emailAOF() {
    this.loader.start();
    const path = 'DIY/DiyAofSend';
    const params = {
      ReferenceNumber: this.erefNo,
    };
    const checkSum = this.erefNo;
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data: any) => {
        let val = this.http.decryptUsingAES256(data.OutPut);
        if (val.IsSuccess) {
          this.loader.stop();
          // this.toastr.success("Success")
        }
      },
      error: (e) => {
        this.loader.stop();
        this.toastr.error(e.error.Message);
      },
    });
  }
  // GeneratePDF() {
  //   this.loader.start();
  //   const path = 'DIY/GeneratePDFDocument';
  //   const params = {
  //     ReferenceNumber: this.erefNo,
  //     PanNumber: this.panNumber ? this.panNumber : '',
  //     IsDBO: false,
  //     NRO: this.NRO,
  //   };
  //   const checkSum = this.erefNo + this.panNumber;
  //   this._http.httpPost(path, params, checkSum).subscribe({
  //     next: (data: any) => {
  //       let val = this.http.decryptUsingAES256(data.OutPut);
  //       if (val) {
  //         this.loader.stop();
  //         if (this.EsignStatus?.toLowerCase() === 'failed') {
  //           // if (this.esignMessage === '112') {
  //           //   this.errorComp.ModalShow("Customer Mobile No. or Email id not linked with entered Aadhaar No.");
  //           // }
  //           // if (this.esignMessage === 'ESP-944') {
  //           //   this.errorComp.ModalShow('Session timed out or Customer has cancelled the Esign process');
  //           // }
  //           // if (this.esignMessage === 'ESP-945') {
  //           //   this.errorComp.ModalShow('Customer has cancelled Esign OTP authentication process');
  //           // }
  //           // if (this.esignMessage === 'ESP-415') {
  //           //   this.errorComp.ModalShow('Invalid OTP was provided by customer for Esign authentication process');
  //           // } else {
  //           this.errorComp.ModalShow(this.Esignmsg);
  //           // }
  //           // this.errorComp.ModalShow(this.Esignmsg);
  //         }
  //       }
  //     },
  //     error: (e) => {
  //       this.loader.stop();
  //       this.toastr.error(e.error.Message);
  //     },
  //   });
  // }
  GeneratePDF() {
    this.loader.start('loader2');
    const path = 'DIY/GeneratePDFDocument';
    const params = {
      ReferenceNumber: this.erefNo,
      PanNumber: this.panNumber ? this.panNumber : '',
      IsDBO: false,
      NRO: this.NRO,
    };
    const checkSum = this.erefNo + this.panNumber;
    // this.loader.start();
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data: any) => {
        try {
          const val = this.http.decryptUsingAES256(data.OutPut);
          // this.loader.start();
          if (val) {
            if (this.EsignStatus?.toLowerCase() === 'failed') {
              this.errorComp.ModalShow(this.Esignmsg);
            } else {
              // TODO: handle the success/PDF-ready case here
              // e.g. this.pdfUrl = val; or trigger download/view
            }
          } else {
            this.toastr.error(
              'Unable to process the document. Please try again.',
            );
          }
        } catch (err) {
          console.error('GeneratePDF decrypt/handling error:', err);
          this.toastr.error(
            'Something went wrong while generating the document.',
          );
        } finally {
          this.loader.stop('loader2');
        }
      },
      error: (e) => {
        this.loader.stop('loader2');
        this.toastr.error(e?.error?.Message || 'Failed to generate document.');
      },
    });
  }
  downloadAOF() {
    this.loader.start();
    const path = 'DIY/DiyAofDownload';
    const params = {
      ReferenceNumber: this.erefNo,
    };
    const checkSum = this.erefNo;
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data: any) => {
        let val = this.http.decryptUsingAES256(data.OutPut);
        if (val.IsSuccess) {
          this.loader.stop();

          if (val.Pdf) {
            const byteArray = new Uint8Array(
              atob(val.Pdf)
                .split('')
                .map((char) => char.charCodeAt(0)),
            );
            // const pdfContent = atob(data.Pdf);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const filename = `Aof.pdf`;
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;

            setTimeout(() => {
              a.click();
              URL.revokeObjectURL(url);
            }, 0);

            // this.toastr.success("PDF Downloaded Successfully");
          } else {
            this.toastr.error('PDF content not found in the response.');
          }
        }
      },
      error: (e) => {
        this.loader.stop();
        this.toastr.error(e.error.Message);
      },
    });
  }
  // previewAOF() {
  //   this.loader.start();
  //   const path = "DIY/DiyAofDownload";
  //   const params = {
  //     "ReferenceNumber": this.erefNo
  //   }
  //   const checkSum = this.erefNo;

  //   this._http.httpPost(path, params, checkSum).subscribe({
  //     next: (data: any) => {
  //       if (data.IsSuccess && data.Pdf) {
  //         this.loader.stop();

  //         const pdfBlob = this.base64toBlob(data.Pdf, 'application/pdf');

  //         const pdfUrl = URL.createObjectURL(pdfBlob);

  //         // Sanitize and assign the URL to objURl
  //         this.objURl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
  //       } else {
  //         this.loader.stop();
  //         this.toastr.error("PDF data not found in the response");
  //       }
  //     },
  //     error: e => {
  //       this.loader.stop();
  //       this.toastr.error(e.error.Message);
  //     }
  //   });
  // }
  // previewAOF() {
  //   this.loader.start();
  //   const path = "DIY/DiyAofDownload";
  //   const params = {
  //     "ReferenceNumber": this.erefNo
  //   }
  //   const checkSum = this.erefNo;

  //   this._http.httpPost(path, params, checkSum).subscribe({
  //     next: (data: any) => {
  //       if (data.IsSuccess && data.Pdf) {
  //         this.loader.stop();

  //         const pdfBlob = this.base64toBlob(data.Pdf, 'application/pdf');
  //         const pdfUrl = URL.createObjectURL(pdfBlob);
  //         this.pdfViewer.nativeElement.src = pdfUrl;
  //       } else {
  //         this.loader.stop();
  //         this.toastr.error("PDF data not found in the response");
  //       }
  //     },
  //     error: e => {
  //       this.loader.stop();
  //       this.toastr.error(e.error.Message);
  //     }
  //   });
  // }

  // base64toBlob(base64Data: string, contentType: string = '', sliceSize: number = 512): Blob {
  //   const byteCharacters = atob(base64Data);
  //   const byteArrays = [];

  //   for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
  //     const slice = byteCharacters.slice(offset, offset + sliceSize);

  //     const byteNumbers = new Array(slice.length);
  //     for (let i = 0; i < slice.length; i++) {
  //       byteNumbers[i] = slice.charCodeAt(i);
  //     }

  //     const byteArray = new Uint8Array(byteNumbers);
  //     byteArrays.push(byteArray);
  //   }

  //   return new Blob(byteArrays, { type: contentType });
  // }

  stageValidate() {
    this.loader.start();
    const path = 'DIY/DiyUpdtStatus';

    const params = {
      ReferenceNumber: this.erefNo,
      Status: 'Completed',
    };

    let checksum = this.erefNo + 'Completed';

    this._http.httpPost(path, params, checksum).subscribe({
      next: (data: any) => {
        let val = this.http.decryptUsingAES256(data.OutPut);
        if (val.IsSuccess) {
          this.loader.stop();
          // this.toastr.success(val.Success);
          sessionStorage.setItem('stageFinished', val.IsSuccess);
          const refNo = val.ReferenceNumber;
          setTimeout(() => {
            this.router.navigate(['/complete'], {
              state: { RefNo: refNo },
              replaceUrl: true,
            });
          }, 500);
        }
      },
      error: (e) => {
        this.loader.stop();
        this.toastr.error(e.error.Message);
      },
    });
  }
}
